<template>
  <div class="rangeSelect pt-8">
    <div class="rangeSelect-wrp" :style="{gridTemplateColumns: `repeat(${4}, 1fr)`}"
    >
      <div
          v-for="(el, index) in optionsLength"
          :key="el.level"
          class="rangeSelect-el"
          :class="{
            'level0': index === 0,
            'levelBord1': index === 0,
            'levelBord2': index === 1,
            'greenLevel1': reactionsLevel === 1 && optionsLength[index].level < 2 && optionsLength[index].level !== 0 || defsettings?.threshold === 'low' && optionsLength[index].level < 2 && optionsLength[index].level !== 0,
            'greenLevel2': reactionsLevel === 2 && optionsLength[index].level < 3 && optionsLength[index].level !== 0 || defsettings?.threshold === 'medium' && optionsLength[index].level < 3 && optionsLength[index].level !== 0,
            'greenLevel3': reactionsLevel === 3 && optionsLength[index].level < 4 && optionsLength[index].level !== 0 || defsettings?.threshold === 'high' && optionsLength[index].level < 4 && optionsLength[index].level !== 0 ,
          }"
          @click="handleSetValue(el.value, el.level)"
      >
        <div class="rangeSelect-el-line" :class="`color-${Math.abs(el.value)}`">
        </div>
        <div class="rangeSelect-el-txt"
             :class="clsx({
                'selected': model >= Math.abs(el.value)
             }, `color-${el.level}`)"
        >
          {{ el.name }}
        </div>
      </div>
    </div>

    <span class="rangeSelect-el-circle" :class="`color-${model}`" :style="{left: positionBullet}"
    ></span>
  </div>
</template>

<script setup>
import {computed, ref, onMounted} from 'vue';
import clsx from 'clsx';
const emit = defineEmits(["update:model-value"]);
const props = defineProps(['defsettings'])
const level = ref(0);
const reactionsLevel = ref(0);
const model = defineModel()
const isRed = ref(false);

const positionBullet = computed(() => {
  if(props.defsettings?.threshold === 'off') {
    level.value = 0;
  }
  if(props.defsettings?.threshold === 'low') {
    level.value = 1;
  }
  if(props.defsettings?.threshold === 'medium') {
    level.value = 2;
  }
  if(props.defsettings?.threshold === 'high') {
    level.value = 3;
  }
  if(level.value < 1) {
    isRed.value = true;
  } else {
    isRed.value = false;
  }
  if (level.value) {
    return positionsBullet[level.value] + '%'
  }
  return '35px'
})

function handleSetValue(value, position) {
  if(value == 0) {
    emit("update:model-value", value);
  }
  props.defsettings.threshold = null;
  reactionsLevel.value = value;
  level.value = position;
  model.value = value;
}

const optionsLength = [
  {level: 0, value: 0, name: 'Off'},
  {level: 1, value: 1, name: 'Low'},
  {level: 2, value: 2, name: 'Medium'},
  {level: 3, value: 3, name: 'High'},
]

const positionsBullet = [10, 35, 60, 85]
</script>

<style scoped lang="scss">
.rangeSelect {
  position: relative;

  &-wrp {
    display: grid;
    width: 100%;
  }
  &.hasSelected {
    .rangeSelect-el-line {
      background: var(--colorHovered);
      border-color: var(--colorHovered);
      border-left-color: #959595;
    }
  }

  &-el {
    cursor: pointer;
    position: relative;
    &.level0 {
      border: 2px solid #1d1d21;
      border-radius: 20px;
      height: 14px;
      margin-top: -2px;
    }
    &.levelBord1 .rangeSelect-el-line {
      border-radius: 40px;
    }
    &.levelBord2 .rangeSelect-el-line {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
    &.greenLevel1 .rangeSelect-el-line {
      background-color: #17833F;
      border-color: #17833F;
      box-shadow: 0 0 7px #17833F;
    }
    &.greenLevel2 .rangeSelect-el-line {
      background-color: #1CA44E;
      border-color: #1CA44E;
      box-shadow: 0 0 7px #1CA44E;
    }
    &.greenLevel3 .rangeSelect-el-line {
      background-color: #22C55E;
      border-color: #22C55E;
      box-shadow: 0 0 7px #22C55E;
    }

    &-circle {
      border: 3px solid #fff;
      width: 16px;
      pointer-events: none;
      border-radius: 50%;
      background: var(--color);
      position: absolute;
      top: 29px;
      height: 16px;
      transition: left .3s ease-in-out;
      z-index: 1;
      box-shadow: 0 0 7px #fff;
    }

    &-txt {
      text-align: center;
      margin-top: 4px;
      font-size: 12px;
      color: #A1A1AA;
      transition: .2s;
    }

    &:last-child {
      .rangeSelect-el-line {
        border-radius: 0 40px 40px 0;
      }
    }

    &-line {
      background: #464648;
      border: 2px solid #464648;
      height: 10px;
      position: relative;
      z-index: 0;
      transition: .15s;
    }

    &.selected {
      .rangeSelect-el-line {
        box-shadow: 0 0 7px var(--colorSelected);
        background: var(--colorSelected);
        border: 2px solid var(--colorSelected);
      }
    }

    &.active {
      .rangeSelect-el-line {
        background: var(--color);
      }
    }
  }


}
</style>
